// Enumerations
import { KycMethodsEnumeration } from 'containers/kyc/enumerations/kyc-methods.enumeration';
// Translations
import {
  KYC_LANDING_ACCOUNT_CHECK_OPTION,
  KYC_LANDING_BIZUM_OPTION,
  KYC_LANDING_VIDEOCALL_OPTION,
} from '../translations/kyc-landing.configuration.translations';
// Variants
import { VARIANTS } from '@openbank/ziniaweb-ui-components';

const KYC_LANDING_FEATURES_CONFIGURATION = {
    [KycMethodsEnumeration.ACCOUNT_CHECK]: {
      description: KYC_LANDING_ACCOUNT_CHECK_OPTION.description,
      icon: 'icon_categories_organizations-and-ongs',
      title: KYC_LANDING_ACCOUNT_CHECK_OPTION.title,
    },
    [KycMethodsEnumeration.BIZUM]: {
      description: KYC_LANDING_BIZUM_OPTION.description,
      icon: 'icon_arrow_trade',
      title: KYC_LANDING_BIZUM_OPTION.title,
    },
    [KycMethodsEnumeration.VIDEOCALL]: {
      description: KYC_LANDING_VIDEOCALL_OPTION.description,
      icon: 'icon_people_account-user',
      title: KYC_LANDING_VIDEOCALL_OPTION.title,
    },
  },
  KYC_LANDING_MODAL_CHILDREN_PARAGRAPH_PROPS = {
    'data-testid': 'kyc-landing-bizum-modal-description',
  },
  KYC_LANDING_MODAL_CONSENT_PROPS = {
    radioButton: false,
    variant: VARIANTS.SelectorRowVariants.CUSTOM,
  },
  KYC_LANDING_MODAL_CONSENT_CHECKBOX_PROPS = {
    variant: 'REGULAR',
  },
  KYC_LANDING_MODAL_CONSENT_PARAGRAPH_PROPS = {
    size: VARIANTS.ParagraphSizesType.CAPTION_MEDIUM,
  };

export {
  KYC_LANDING_FEATURES_CONFIGURATION,
  KYC_LANDING_MODAL_CHILDREN_PARAGRAPH_PROPS,
  KYC_LANDING_MODAL_CONSENT_PROPS,
  KYC_LANDING_MODAL_CONSENT_CHECKBOX_PROPS,
  KYC_LANDING_MODAL_CONSENT_PARAGRAPH_PROPS,
};
